import { Component } from '@angular/core';
import { NavController, LoadingController, AlertController } from 'ionic-angular';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

import { Storage } from '@ionic/storage';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

@Component({
	selector: 'page-dados',
  	templateUrl: 'dados.html',
})

export class DadosPage {

	form = {id:0, nome:'', email:'', senha:''};
	usuario = {nome:'', email:''};

	alterarDados = false;

	facebook = 0;


	constructor(public navCtrl: NavController, private _apiService: ApiProvider, private loadingCtrl: LoadingController, private storage: Storage, private alertCtrl: AlertController, private _msg: TranslateMsgProvider)
	{
		let loading = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+'...'
        });
        loading.present();

        // Primeiro pega o id do cliente
        storage.get('id_cliente').then((val) => {
            this.form.id = val;

	        /* Busca informações da empresa */
	    	this._apiService.dadosUser({id_cliente: val}).subscribe(arg => {
	            // console.log(arg);
	            this.form.nome = arg.nome;
	            this.usuario.nome = arg.nome;
	            this.form.email = arg.email;
	            this.usuario.email = arg.email;
        		storage.get('facebook').then((f) => {
	            	this.facebook = f;
					loading.dismiss();
        		});
	        })
        });
	}

	/* Alterar dados */
	alterarDadosShow()
	{
		this.alterarDados = true;
	}

	/* Atualiza os dados do form */
	atualizar()
	{
		// console.log(this.form);
		let loading = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+'...'
        });
        loading.present();

        this._apiService.saveUser(this.form).subscribe(arg => {
        	// console.log(arg);
			loading.dismiss();
        	if(arg == 1)
        	{
        		let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('SUCESSO'),
		            subTitle: this._msg.getMsg('SUCESSO_EDITADO'),
		            buttons: [{text: 'OK'}]
		        });
		        alert.present();

        		this.usuario.nome = this.form.nome;
        		this.usuario.email = this.form.email;
        	}
        	else
        	{
        		let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('ERRO'),
		            subTitle: this._msg.getMsg('ERRO_ALTERACAO'),
		            buttons: [{text: 'OK'}]
		        });
		        alert.present();
        	}
        });
	}

}



// WEBPACK FOOTER //
// ./src/pages/dados/dados.ts